import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import "./plugins/flatpicker";
import "core-js/stable";
import "regenerator-runtime/runtime";
// import 'roboto-fontface/css/roboto/roboto-fontface.css'
import "@fortawesome/fontawesome-free/css/all.css";
import "./assets/css/loader.css";
import "./assets/css/style.css";
import "./assets/css/acessibilidade.css";
import "./plugins/foco-teclado";
import abasAcessiveis from "./directives/abas-acessiveis";
import modalAcessivel from "./directives/modal-acessivel";
import dropdownAcessivel from "./directives/dropdown-acessivel";
import erroAcessivel from "./directives/erro-acessivel";
import paginacaoAcessivel from "./directives/paginacao-acessivel";
import calendarioAcessivel from "./directives/calendario-acessivel";

Vue.directive("abas-acessiveis", abasAcessiveis);
Vue.directive("modal-acessivel", modalAcessivel);
Vue.directive("dropdown-acessivel", dropdownAcessivel);
Vue.directive("erro-acessivel", erroAcessivel);
Vue.directive("paginacao-acessivel", paginacaoAcessivel);
Vue.directive("calendario-acessivel", calendarioAcessivel);

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

Vue.prototype.$root = new Vue();
